export const categories = [
  {
    slug: 'wenhua-chuancheng',
    name: '文化传承',
    description: '探索亚洲悠久历史与传统文化精髓，感受千年文明的深厚底蕴',
    icon: 'ri-building-2-line',
    color: 'primary',
  },
  {
    slug: 'yule-zixun',
    name: '娱乐资讯',
    description: '追踪亚洲最新影视音乐动态，掌握潮流娱乐前沿风向',
    icon: 'ri-movie-2-line',
    color: 'accent',
  },
  {
    slug: 'shenghuo-fangshi',
    name: '生活方式',
    description: '分享亚洲现代生活美学，从家居到穿搭的品质生活指南',
    icon: 'ri-heart-pulse-line',
    color: 'secondary',
  },
  {
    slug: 'meishi-tansuo',
    name: '美食探索',
    description: '走进亚洲各地美食文化，品味舌尖上的东方魅力',
    icon: 'ri-restaurant-2-line',
    color: 'primary',
  },
  {
    slug: 'keji-qianyan',
    name: '科技前沿',
    description: '聚焦亚洲科技创新突破，解读最新技术趋势与应用',
    icon: 'ri-cpu-line',
    color: 'accent',
  },
  {
    slug: 'lvyou-tuijian',
    name: '旅游推荐',
    description: '发现亚洲秘境旅行目的地，规划你的下一段东方之旅',
    icon: 'ri-earth-line',
    color: 'secondary',
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});